import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MenuIcon from '@material-ui/icons/Menu';
import { pageUrls } from 'globalconfig/constants/keys';
import { getAuthDetails } from 'globalutils/commonUtils';
import { setLanguage, showLanguageCode } from 'globalutils/commonUtils';
import { removeLocalStorage } from 'globalservices/storage';

const isTopLevelWindow = () => {
  try {
    return window.top === window.self;
  } catch {
    return false;
  }
};

const FleetLocateLoginMenu = ({ Styled, handleLogout }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  if (!isTopLevelWindow()) {
    return null;
  }

  const handleOnLanguage = () => {
    setLanguage(i18n);
    setOpen(false);
  };

  const handleOnLogout = () => {
    setOpen(false);
    const auth = getAuthDetails(false);
    if (auth && handleLogout) {
      handleLogout({
        apiId: 'logout',
        callback: (type) => {
          if (type !== 'error') {
            removeLocalStorage('currentLayout');
            window.location.href = pageUrls.login;
          }
        },
      });
    } else {
      window.location.href = pageUrls.login;
    }
  };

  return (
    <Styled.LoginMenuBar ref={menuRef}>
      <Styled.LoginMenuTrigger
        type="button"
        aria-label="Menu"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <MenuIcon />
      </Styled.LoginMenuTrigger>
      {open && (
        <Styled.LoginMenuDropdown>
          <Styled.LoginMenuItem type="button" onClick={handleOnLanguage}>
            {i18n.t(`common.${showLanguageCode('en', false)}`)}
          </Styled.LoginMenuItem>
          <Styled.LoginMenuItem type="button" onClick={handleOnLogout}>
            {i18n.t('avatarMenu.logout')}
          </Styled.LoginMenuItem>
        </Styled.LoginMenuDropdown>
      )}
    </Styled.LoginMenuBar>
  );
};

FleetLocateLoginMenu.propTypes = {
  Styled: PropTypes.object.isRequired,
  handleLogout: PropTypes.func,
};

FleetLocateLoginMenu.defaultProps = {
  handleLogout: null,
};

export default FleetLocateLoginMenu;
